import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { BillingPlansHttpClient } from '../../billing-plans-http-client';
import { BillingEstimateActions } from './billing-estimate.store';

@Injectable({ providedIn: 'root' })
export class BillingEstimateEffects {
  public effect = createEffectFactory(BillingEstimateActions, this.actions$);

  public fetchBillingEstimate$ = this.effect(BillingEstimateActions.fetch, ({ payload }) =>
    this.billingPlansHttpClient.fetchBillingEstimate(payload),
  );

  constructor(
    private billingPlansHttpClient: BillingPlansHttpClient,
    private actions$: Actions,
  ) {}
}
